import { fetchConToken } from "../helpers/fetch";
import { types } from "../types/types";
import { initLoadPayments } from "./payments";

export const startClient=()=>{
    return async(dispatch)=>{
        try {
            const resp = await fetchConToken('cliente');
            const cliente = await resp.json();
            
            await dispatch( clientLoading(cliente) );
            await dispatch( initLoadPayments() );
            
        } catch (error) {
            console.log(error);
        }
        
    }
}

export const registerEvent= () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('eventos/registrarse');
            const body = await resp.json();
            await dispatch( clientAddEvent(body.data.eventoTemp) );
            return;
        } catch (error) {
            console.log(error)
        }
    }
}

export const clientAddEvent = (eventos) => ({
    type: types.eventsAdd,
    payload: eventos,
})

export const clientLoading =(cliente)=>({
    type:types.clientLoading,
    payload:cliente,
})

export const clientLogout = () => ({
    type: types.clientLogout
})

export const clientLoadRoom = (id) => ({
    type: types.clientAddingRoom,
    payload: id
})

export const clientLoadFinishRedes = () => ({
    type: types.clientFinishRedes,
    payload: "1"
})